
<div id="app">
  <router-view />
</div>
